import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreItemCategory } from '@flecto/types'

type UseCategoryUpdateSchemaOptions = {
  category?: Partial<CoreItemCategory>
}

export function useCategoryUpdateFormSchema(
  options?: UseCategoryUpdateSchemaOptions
) {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const schema = z.object({
    description: z.string().nullable().optional(),
    name: z.string().min(1, { message: t('required', { min: 1 }) }),
    parent_id: z.number().nullable().optional(),
    thumbnail_image_id: z.string().nullable().optional(),
  })

  const initialValues: Partial<CoreItemCategory> = {
    ...options?.category,
  }

  return { schema, initialValues }
}
